import React from 'react'
import Box from "@mui/material/Box"
import FormControl from "@mui/material/FormControl"
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'
import IconButton from '@mui/material/IconButton'
import AddIcon from '@mui/icons-material/Add';
import Typography from '@mui/material/IconButton'
import StoreForm from './form'
import {Context as StoreContext} from '../../contexts/Store'
import { useTheme } from '@emotion/react'



const Stores = () => {
    const theme = useTheme()
    const { store, stores, selectStore, create  } = React.useContext(StoreContext)
    const [open, setOpen] = React.useState(false)
    const handleSelect = (e)=>{
        const target = e.currentTarget || e.target
        selectStore(target.value)
    }
    const handleAddStore = () => {
        setOpen(true)
    }
    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'row',
            alignItems: 'center',
        }}>
            <Typography>
                {!store && "Selecciona la tienda"}
            </Typography>
            
            {stores && 
                <FormControl sx={{ m: 1, width: '25ch' }}>
                    <InputLabel sx={{color: theme.palette.contrast.main }} color='contrast' id={"label-store"}>Tienda</InputLabel>
                    <Select
                        sx={{color: theme.palette.contrast.main }}
                        labelId="label-store"
                        name="store"
                        label="Tienda"
                        variant='outlined'
                        color='contrast'
                        value={store?store.name:null}
                        onChange={handleSelect}
                        >
                            {stores.map(s => 
                                (
                                    <MenuItem sx={{borderRightColor: s.color+'!important', borderRight: '5px solid', }} value={s.name}>{s.name}</MenuItem>
                                )
                            )}
                    </Select>
                </FormControl>
            }
            <IconButton onClick={handleAddStore}>
                <AddIcon></AddIcon>
            </IconButton>
            <StoreForm submit={create} open={open} close={() => setOpen(false)}/>
        </Box>
    )
}
        
export default Stores